export default (value, separator = ',') => {
  if (typeof value === 'number') {
    return value;
  }

  if (separator === '.') {
    return value;
  }

  return value?.replace(/\./g, separator);
};
